import React from 'react';
import utils from '../../../../services/utils';
import FieldBold from '../../../Fields/FieldBold/FieldBold';

import classes from './InfoSalaryResume.module.scss';

const InfoSalaryResume = ({ collaborator }) => {
  const { salaryValue } = collaborator;
  return (
    <div className={classes.content}>
      <span className='semibold-18'>Información salarial</span>
      <div className={classes.fields}>
        {/* <FieldBold title='SALARIO COMPLETO' value={utils.moneyFormat(salaryComplete)} /> */}
        <FieldBold title='SALARIO BASE' value={utils.moneyFormat(salaryValue)} />
      </div>
    </div>
  );
};

export default InfoSalaryResume;
